import { ReasonCategory, VoluntaryReason } from '../types';
import { SET_SELECTED_REASON } from './actions';
const initialState = {
    category: ReasonCategory.Voluntary,
    reason: VoluntaryReason.PlansChanged,
    docs: []
};
function selectedReasonsReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_SELECTED_REASON:
            return payload;
        default:
            return state;
    }
}
export default selectedReasonsReducer;
